import Immutable from 'seamless-immutable';
import consts from './consts';

const CTXS = consts.CONTEXTS;

export const getNewList = () => ({
  items: [],
  selected: [],
  cursor: null,
  inProgress: false,
  lastSelectedIndex: -1,
});

export default () =>
  Immutable({
    __record: 'FacebookRecord',
    lists: {
      [CTXS.ALBUM_PHOTOS]: getNewList(),
      [CTXS.TAGGED_PHOTOS]: getNewList(),
      [CTXS.UPLOADED_PHOTOS]: getNewList(),
      [CTXS.ALBUMS]: getNewList(),
    },

    auth: null,
    authProgressIndicator: false,
    albumData: null,
    user: null,
    currentContext: CTXS.UPLOADED_PHOTOS,
  });
